import moment from 'moment'
import { defineObject } from '@/lib/define/use-define'
import { creationDate } from '@/lib/format/use-data-format'
import apiConnect from '@/lib/api-connect'
import apiStatus from '@/lib/api-status'
import sessionStrageUtils from '@/lib/sessionStrage/session-strage-utils'
export const TABS = {
  DEVELOPMENT_SUPPERT: 0,
  AFTER_SCHOOL_DAY_SERVICE: 1,
} as const
export const AFFILIATION = {
  DEVELOPMENT_SUPPERT: '1',
  AFTER_SCHOOL_DAY_SERVICE: '0',
} as const

const katakanaToHiragana = (src: string) => {
  return src.replace(/[\u30a1-\u30f6]/g, (match: string) => {
    const chr = match.charCodeAt(0) - 0x60
    return String.fromCharCode(chr)
  })
}

const sortAllFunc = (firstElement: any, secondElement: any) => {
  const firstLastKana = katakanaToHiragana(firstElement.staffKana.toString())
  const secondLastKana = katakanaToHiragana(secondElement.staffKana.toString())
  if (firstLastKana < secondLastKana) return -1
  else if (firstLastKana > secondLastKana) return 1
  return 0
}

const handleSortAllKana = (data: any) => {
  data.sort(sortAllFunc)
  return data
}

export const handleSortQualificationArray = (
  data: { [key: string]: string }[]
) => {
  data.sort(
    (a: { [key: string]: string }, b: { [key: string]: string }) =>
      Number(a.qualification_no) - Number(b.qualification_no)
  )

  return data
}

export const handleSetStaffQualification = (
  staffData: { [key: string]: string }[],
  qualificationData: { [key: string]: string }[]
) => {
  staffData.forEach((staff: any) => {
    if (Array.isArray(staff.qualification)) {
      const qualificationArray: { [key: string]: string }[] = []

      staff.qualification.some((qualificationId: string) => {
        const setQualificationData = qualificationData.find(
          (qualification: { [key: string]: string }) =>
            qualification.id === qualificationId
        )

        if (!setQualificationData) return true

        qualificationArray.push(setQualificationData)
      })

      staff.qualificationArray = []

      staff.qualificationArray.push(
        ...handleSortQualificationArray(qualificationArray)
      )

      staff.qualificationView = []

      staff.qualificationView = staff.qualificationArray.map(
        (qualification: { [key: string]: string }) => qualification.abbreviation
      )
    }
  })

  return staffData
}

// 児童をもとに指導員の人員配置基準数をカウント
const dayMinStaffCnt = (
  year: number,
  month: number,
  day: number,
  state: any
) => {
  let dayMinStaffCnt: string | number = '-'

  state.cldAtAllArray.forEach((cldAttendance: any) => {
    const dateKeySplitArray = Object.keys(cldAttendance)[0].split('-')

    const dateKeySplitYear = dateKeySplitArray[0]
    const dateKeySplitMonth = dateKeySplitArray[1]
    const dateKeySplitDay = dateKeySplitArray[2]

    if (
      Number(dateKeySplitYear) === year &&
      Number(dateKeySplitMonth) === month &&
      Number(dateKeySplitDay) === day &&
      moment(`${year}-${month}-${day}`, 'YYYY-MM-DD').isSameOrAfter(
        moment(new Date(new Date().toDateString()), 'YYYY-MM-DD')
      )
    ) {
      dayMinStaffCnt = 0

      const dayCldAttendance = cldAttendance[
        Object.keys(cldAttendance)[0]
      ].filter((cldAttendanceData: { [key: string]: string | number }) => {
        if (cldAttendanceData.flg !== 1) return false
        return state.cldAllArray.some(
          (cldInfo: { [key: string]: string | number }) => {
            if (cldInfo.id !== cldAttendanceData.cld_id) return false
            if (state.isTokureiOffice) return true
            return state.tabs === TABS.DEVELOPMENT_SUPPERT
              ? cldInfo.affiliation === AFFILIATION.DEVELOPMENT_SUPPERT
              : cldInfo.affiliation === AFFILIATION.AFTER_SCHOOL_DAY_SERVICE
          }
        )
      }).length

      // 出欠レコードのうち、出席が0件の場合無効
      if (dayCldAttendance === 0) {
        dayMinStaffCnt = '-'
      } else {
        if (dayCldAttendance <= 10) {
          dayMinStaffCnt = 2
        } else {
          for (let index = 0; index < dayCldAttendance; index++) {
            if (index % 5 === 0) {
              dayMinStaffCnt++
            }
          }
        }
      }
    }
  })

  return dayMinStaffCnt
}

// 常勤の指導員をカウント
const handleFilterAtStaffOfFullTimeInstructor = (
  dayFilterAttendance: any,
  state: any
) => {
  let AtStaffOfFullTimeInstructorCnt = 0

  dayFilterAttendance.forEach((attendance: { [key: string]: any }) => {
    const targetStaff = state.staffAllArray.find(
      (staff: any) =>
        staff.staff_id === attendance.staff_id &&
        staff.employee_type === 1 &&
        staff.qualification &&
        staff.qualification.length !== 0
    )

    if (targetStaff) {
      const targetStaffQualification = state.qualificationArray.filter(
        (qualification: { [key: string]: any }) =>
          Array.isArray(targetStaff.qualification) &&
          targetStaff.qualification.some(
            (staffQualification: string) =>
              staffQualification === qualification.id
          )
      )

      if (
        targetStaffQualification.some(
          (qualificationData: { [key: string]: any }) =>
            qualificationData.staffing_flg.some(
              (qualificationFlg: string) => qualificationFlg === '1'
            )
        )
      ) {
        AtStaffOfFullTimeInstructorCnt++
      }
    }
  })

  return AtStaffOfFullTimeInstructorCnt
}

// 指導員をカウント
const handleFilterAtStaffOfInstructor = (
  dayFilterAttendance: any,
  state: any
) => {
  let AtStaffOfInstructorCnt = 0

  dayFilterAttendance.forEach((attendance: { [key: string]: any }) => {
    const targetStaff = state.staffAllArray.find(
      (staff: any) =>
        staff.staff_id === attendance.staff_id &&
        staff.qualification &&
        staff.qualification.length !== 0
    )

    if (targetStaff) {
      const targetStaffQualification = state.qualificationArray.filter(
        (qualification: { [key: string]: any }) =>
          Array.isArray(targetStaff.qualification) &&
          targetStaff.qualification.some(
            (staffQualification: string) =>
              staffQualification === qualification.id
          )
      )

      if (
        targetStaffQualification.some(
          (qualificationData: { [key: string]: any }) =>
            qualificationData.staffing_flg.some(
              (qualificationFlg: string) => qualificationFlg === '1'
            )
        )
      ) {
        AtStaffOfInstructorCnt++
      }
    }
  })

  return AtStaffOfInstructorCnt
}

// 看護師、機能訓練担当員を指導員としてカウント
const handleFilterAtStaffOfSpecialCaseInstructor = (
  dayFilterAttendance: any,
  state: any
) => {
  let attendanceSpecialCaseInstructorCnt = 0

  dayFilterAttendance.forEach((attendance: { [key: string]: any }) => {
    const targetStaff = state.staffAllArray.find(
      (staff: any) =>
        staff.staff_id === attendance.staff_id &&
        staff.qualification &&
        staff.qualification.length !== 0
    )

    if (targetStaff) {
      const targetStaffQualification = state.qualificationArray.filter(
        (qualification: { [key: string]: any }) =>
          Array.isArray(targetStaff.qualification) &&
          targetStaff.qualification.some(
            (staffQualification: string) =>
              staffQualification === qualification.id
          )
      )

      if (
        targetStaffQualification.every(
          (qualificationData: { [key: string]: any }) =>
            qualificationData.staffing_flg.every(
              (qualificationFlg: string) => qualificationFlg !== '1'
            )
        ) &&
        targetStaffQualification.some(
          (qualificationData: { [key: string]: any }) =>
            qualificationData.staffing_flg.some(
              (qualificationFlg: string) => qualificationFlg === '4'
            )
        )
      ) {
        attendanceSpecialCaseInstructorCnt++
      }
    }
  })

  return attendanceSpecialCaseInstructorCnt
}

export const atStaffCntArraySet = (state: any) => {
  const atStaffCntArray = []

  atStaffCntArray.push(
    ...creationDate(
      Number(state.selectLastDay) - 1,
      Number(state.selectYear),
      Number(state.selectMonth),
      1
    )
  )

  atStaffCntArray.forEach((date: { [key: string]: any }) => {
    date.errMsg = [] as string[]

    const dayAllAttendance = state.staffAtAllArray.filter(
      (staffAttendance: { [key: string]: string | number }) =>
        staffAttendance.year === date.year &&
        staffAttendance.month === date.month &&
        staffAttendance.day === date.day &&
        staffAttendance.flg === '1'
    )

    const dayFilterAttendance = dayAllAttendance.filter(
      (attendance: { [key: string]: any }) => {
        let staffArray = state.staffAllArray.filter(
          (staff: { [key: string]: number | string }) =>
            staff.staff_id === attendance.staff_id
        )

        // 特例事業所でない場合、staffArray を affiliation に応じて絞り込み
        if (!state.isTokureiOffice) {
          staffArray = staffArray.filter(
            (staff: { [key: string]: number | string }) =>
              state.tabs === TABS.DEVELOPMENT_SUPPERT
                ? staff.affiliation === AFFILIATION.DEVELOPMENT_SUPPERT
                : staff.affiliation === AFFILIATION.AFTER_SCHOOL_DAY_SERVICE
          )
        }
        // デフォルト：退職者を含めない
        if (!state.noActiveStaffView) {
          return staffArray.some(
            (staff: { [key: string]: number }) => staff.active === 1
          )
        }

        return staffArray.length > 0 // noActiveStaffView が true の場合、staffArray が空でなければ true を返す
      }
    )

    // 勤務人数
    date.attendanceCnt = dayFilterAttendance.length

    // 児童数に応じた指導員の人為配置数
    date.dayMinStaffCnt = dayMinStaffCnt(date.year, date.month, date.day, state)

    // 勤務する常勤の指導員数
    date.attendanceFullTimeInstructorCnt = handleFilterAtStaffOfFullTimeInstructor(
      dayFilterAttendance,
      state
    )

    if (
      date.dayMinStaffCnt !== '-' &&
      1 > date.attendanceFullTimeInstructorCnt
    ) {
      date.errMsg.push('常勤の指導員が1名不足しております。')
    }

    // 勤務する指導員数
    date.attendanceInstructorCnt = handleFilterAtStaffOfInstructor(
      dayFilterAttendance,
      state
    )

    // 配置基準数に対して半分以上が指導員の場合、看護師または機能訓練担当員も指導員としてカウント
    if (
      date.dayMinStaffCnt !== '-' &&
      Math.ceil(date.dayMinStaffCnt / 2) <= date.attendanceInstructorCnt
    ) {
      date.attendanceSpecialCaseInstructorCnt = handleFilterAtStaffOfSpecialCaseInstructor(
        dayFilterAttendance,
        state
      )

      date.attendanceInstructorCnt =
        date.attendanceSpecialCaseInstructorCnt + date.attendanceInstructorCnt
    }

    // 配置基準数の最終チェック
    if (
      date.dayMinStaffCnt !== '-' &&
      date.dayMinStaffCnt > date.attendanceInstructorCnt
    ) {
      date.errMsg.push('人員配置基準数に対して指導員が不足しております。')
    }
  })

  return atStaffCntArray
}

export const atStaffCntValid = (state: any) => {
  const atStaffCntArray = atStaffCntArraySet(state)

  const alertMsgArray: string[] = []

  atStaffCntArray.forEach((attendance: { [key: string]: any }) => {
    if (attendance.errMsg && attendance.errMsg.length !== 0) {
      alertMsgArray.push(
        `${attendance.month}/${attendance.day}(${
          defineObject.FORMULA_WEEK_ARRAY[attendance.weekNumber]
        })`
      )
    }
  })

  return alertMsgArray
}

export const shiftManagementViewSet = (state: any) => {
  let obj: { [key: string]: string | boolean } = {
    shiftManagementSts: '申請中',
    shiftManagementFlg: '0',
    deadlineBtnText: 'シフト申請を締め切る',
    deadlineBtnDisabledFlg: true,
    nextDeadlineBtnShiftManagementFlg: '1',
    deadlineBtnBgColor: '#2EB85C',
    deadlineBtnTextColor: '#ffffff',
    confirmBtnText: 'シフトを確定する',
    confirmBtnDisabledFlg: true,
    nextConfirmBtnShiftManagementFlg: '2',
    confirmBtnBgColor: '#2EB85C',
    confirmBtnTextColor: '#ffffff',
  }

  if (state.staffAtAllArray.length !== 0) {
    const checkAttendance = state.staffAtAllArray[0]
    const shiftManagementView = state.shiftManagementViewArray.find(
      (shiftManagementView: { [key: string]: string | boolean }) =>
        shiftManagementView.shiftManagementFlg ===
        checkAttendance.shift_management_flg
    )

    if (shiftManagementView) {
      obj = shiftManagementView
    }
  }

  if (state.currentStaff.role !== 1) {
    obj.deadlineBtnDisabledFlg = true
    obj.deadlineBtnBgColor = '#CED2D8'
    obj.deadlineBtnTextColor = '#3C4B64'

    obj.confirmBtnDisabledFlg = true
    obj.confirmBtnBgColor = '#CED2D8'
    obj.confirmBtnTextColor = '#3C4B64'
  }

  return obj
}

export const useSelect = (state: any) => {
  const handleSelectStaffId = (staffId: string, staffName: string) => {
    state.staffParam.dataObject.lastUpdatedByStaffId = staffId
    state.staffParam.dataObject.lastUpdatedByStaffName = staffName
  }

  return {
    handleSelectStaffId,
  }
}

export const usePost = (state: any) => {
  const handlePostData = async () => {
    if (
      Object.keys(state.errorList).length !== 0 ||
      state.isDuplicationCheckError
    ) {
      alert('正しい形式で入力してください')
      return
    }

    state.mainText = 'データを登録・変更中です。'

    state.isShow = false

    state.staffParam.dataObject.id = state.staffParam.dataObject.staffId

    const responsePromise = await apiConnect.postToApiGateway(
      state.staffParam.api,
      state.staffParam.dataObject
    )

    const isStatus = apiStatus.statusHandring(responsePromise.data.meta)

    if (!isStatus) {
      if (responsePromise.data.meta === '2235') {
        alert(state.duplicationCheckErrorMsg)
      } else if (responsePromise.data.meta === '2236') {
        alert('すでに登録済みのログイン用メールアドレスです。')
      } else if (
        responsePromise.data.meta === '2240' ||
        responsePromise.data.meta === '2241'
      ) {
        alert('事業所内に最低1名は在職中の管理者が必要です。')
      } else {
        alert(
          `データを正常に登録できませんでした。エラーコード[${responsePromise.data.meta}]`
        )
      }

      state.isShow = true
      return
    }

    const setStaffInfo = responsePromise.data.data.Items.find(
      (staff: any) =>
        staff.staff_id === state.staffParam.dataObject.lastUpdatedByStaffId
    )

    const currentStaff = sessionStrageUtils.handleGetSessionStorage(
      'currentStaff'
    )

    currentStaff['first_name'] = setStaffInfo.first_name
    currentStaff['last_name'] = setStaffInfo.last_name
    currentStaff.role = setStaffInfo.role

    sessionStrageUtils.handleSetSessionStorage('currentStaff', currentStaff)

    state.mainText = 'データを変更しました。'
    state.subText = '前のページへ戻ります。'
    sessionStrageUtils.handleSetSessionStorage(
      'storedStaffList',
      responsePromise
    )
    location.href = '/staff/list'
  }
  return {
    handlePostData,
  }
}

export const handleSortPickupStaffData = (data: any) => {
  const KanaSortData = handleSortAllKana(data)
  return KanaSortData
}
